import MaterialTable from "@material-table/core";
import MatTableHeader from "../../MaterialTableHeader/MatTableHeader";
import { submittedQuotesTableData } from "../../api";
import { log } from "../../../Helper";
import React, { useEffect, useState } from "react";
import LoaderComponent from "../../../LoaderComponent/LoaderComponent";
import { toast } from "react-toastify";
import ForwarderQuoteDialog from "../../Dialog/quoteDialog";
import { CustomToolTipEditIcon } from "../../../load-build/utility/tooltip";
import { useUserInfo } from "../../../common/user-context";
import { sortByPriceWithCurrency } from "../../../utils/utils";
import useFilterState from "../../../hooks/useFilterState";
import _ from "lodash";

const SubmittedQuotesMaterialTable = ({ tableName }) => {
  const { userData } = useUserInfo();
  const [submittedQuoteData, setSubmittedQuoteData] = useState(Array(0));
  const [pageSize, setPageSize] = useState(200);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMachinesForQuote, setselectedMachinesForQuote] = useState([]);
  const [open, setOpen] = React.useState(false);

  const getSubmittedQuoteTableData = async () => {
    setIsLoading(true);
    try {
      const response = await submittedQuotesTableData(
        pageNumber,
        pageSize,
        userData
      );
      if (!response || !Array.isArray(response)) {
        setSubmittedQuoteData([]);
      } else {
        setSubmittedQuoteData(response);
      }
    } catch (error) {
      log("Error occured when fetching submitted quotes: ", error);
      setSubmittedQuoteData(Array(0));
    }
    setIsLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (userData.length > 0 || userData.userId) {
      getSubmittedQuoteTableData();
    }
  }, [userData]);

  const handleQuoteDialogOpen = (data) => {
    if (userData.internal) {
      toast.warn("Internal user can not edit quote");
      return;
    }
    log("Selected machines for quote ", data);
    setselectedMachinesForQuote(data);
    setOpen(true);
  };

  const columns = [
    {
      title: "Status",
      field: "status",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Comar",
      field: "comar",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Pick-Up",
      field: "pickupLocation",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Destination",
      field: "destination",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Product",
      field: "product",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Dimensions",
      field: "dimension",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Weight",
      field: "weight",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Expected Timeframe",
      field: "expectedTimeframe",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Proposed Date",
      field: "proposedDate",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Amount",
      field: "amount",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
      customSort: (a, b) => {
        return sortByPriceWithCurrency(
          a.amount.props ? a.amount.props.children[0] : a.amount,
          b.amount.props ? b.amount.props.children[0] : b.amount
        );
      },
    },
    {
      title: "Result",
      field: "result",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "PickUp Days",
      field: "pickupDays",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Transit Days",
      field: "transitDays",
      hidden: true,
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
  ];

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <>
      {isLoading && <LoaderComponent />}

      {!isLoading && (
        <div className="flex flex-col justify-center items-center mt-[-1.5rem]">
          <MatTableHeader getTableData={getSubmittedQuoteTableData} />
          <MaterialTable
            columns={columnsWithFilter.map((col, index) => {
              if (
                col.tableData?.filterValue == "" ||
                col.tableData?.filterValue == null ||
                col.tableData?.filterValue == undefined
              ) {
                let colWithoutDefaultFilter = _.omit(
                  col,
                  "defaultFilter",
                  "tableData.filterValue"
                );
                return colWithoutDefaultFilter;
              } else {
                return {
                  ...col,
                  defaultFilter: col.tableData?.filterValue,
                };
              }
            })}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h6 className="left-[45%] absolute top-[40%] text-center">
                    No records to display
                  </h6>
                ),
              },
              pagination: {
                labelRowsPerPage: "Orders Per Page",
                labelRowsSelect: "Orders",
              },
            }}
            options={{
              rowStyle: {
                fontSize: 10,
              },
              search: false,
              showTitle: false,
              grouping: false,
              pageSize: 100,
              filtering: true,
              draggable: false,
              maxBodyHeight: 600,
              headerStyle: {
                backgroundColor: "#367c2b",
                fontWeight: "400",
                color: "white",
                position: "sticky",
                top: 0,
                zIndex: 10,
              },
              tableContainerStyle: {
                maxHeight: 600,
                overflow: "auto",
              },
              pageSizeOptions: [100, 500, 1000],
              actionsColumnIndex: -1,
              filterCellStyle: {
                flex: 1
              },
            }}
            title={"Submitted Quotes"}
            data={submittedQuoteData}
            onFilterChange={(filters) => {
              // Create a map of current filters for quick lookup
              const filterMap = new Map();
              filters.forEach((filter) => {
                filterMap.set(filter.column.tableData.id, filter.value);
              });

              // Iterate over all columns to ensure each one is checked if the value is present in the filter map
              columnsWithFilter.forEach((col, columnId) => {
                const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

                // Update the filter state for each column
                handleFilterChange(columnId, newValue);
              });
            }}
            actions={[
              (rowData) => ({
                icon: () => <CustomToolTipEditIcon />,
                onClick: (event, rowData) => {
                  handleQuoteDialogOpen(rowData);
                },
              }),
            ]}
          />
          <ForwarderQuoteDialog
            open={open}
            handleClose={handleClose}
            selectedMachinesForQuote={selectedMachinesForQuote}
            getTableData={getSubmittedQuoteTableData}
            userData={userData}
          />
        </div>
      )}
    </>
  );
};

export default SubmittedQuotesMaterialTable;
